import { IApiConfiguration } from '~/stores/api';
import { RootState } from '~/stores';

export const isolateApiConfiguration: (s: RootState) => IApiConfiguration = s => s.api;